import { createContext, useContext } from "react";

export interface StepperContextValue {
  activeStep: number;
  direction: number;
  goToStep: (targetStep: number) => void;
  handleAnimationComplete: (definition: string) => void;
  isExiting: boolean;
  nextStep: () => void;
  prevStep: () => void;
  setStep: (step: ((s: number) => number) | number) => void;
  step: number;
  totalSteps: number;
}

export const StepperContext = createContext<null | StepperContextValue>(null);

export function useStepperContext(): StepperContextValue {
  const context = useContext(StepperContext);

  if (!context) {
    throw new Error("useStepperContext must be used within a StepperProvider");
  }

  return context;
}

export function useStepper(): StepperContextValue {
  return useStepperContext();
}
